import { createAction, handleActions } from "redux-actions";
import * as ActionTypes from "./actionType";
import { request } from "utils/apiClient/base";

const initialState = {
  data: {},
  error: {},
  group: ""
};

export default handleActions(
  {
    [`${ActionTypes.PAGE_INIT}_FULFILLED`]: (state, action) => ({
      ...state,
      data: action.payload
    }),
    [`${ActionTypes.PAGE_INIT}_PENDING`]: () => initialState,
    [`${ActionTypes.PAGE_INIT}_REJECTED`]: (state, action) => ({
      ...state,
      error: action.payload
    }),
    [`${ActionTypes.GROUP_GET}_PENDING`]: () => initialState,
    [`${ActionTypes.GROUP_GET}_FULFILLED`]: (state, action) => ({
      ...state,
      group: action.payload
    }),
    [`${ActionTypes.GROUP_GET}_REJECTED`]: (state, action) => ({
      ...state,
      error: action.payload
    })
  },
  initialState
);

export const actionCreators = {
  initPage: createAction(ActionTypes.PAGE_INIT, params => request(270, params)),
  getGroup: createAction(ActionTypes.GROUP_GET, params => request(858, params))
};
